import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { KratosAuthenticationService } from 'src/app/services/authentication/kratos.service';
import { LoadUserAction, LogoutAction } from 'src/app/store/user/user.actions';
import { UserState } from 'src/app/store/user/user.state';

// AuthGuard checks wether a user has a valid session and at least one membership
export const AuthGuard = async () => {
  const router = inject(Router);
  const store = inject(Store);
  const kratos = inject(KratosAuthenticationService);

  try {
    let user = store.selectSnapshot(UserState.getUser);

    // when user is empty we probably did not fetch it yet as the user just logged in -> fetch
    if (!user) {
      await firstValueFrom(store.dispatch(new LoadUserAction()));
      user = store.selectSnapshot(UserState.getUser);
    }

    if (!user) {
      throw new Error('No user');
    }

    // validate session
    let session = store.selectSnapshot(UserState.getSession);
    if (!session || Date.now() > session?.expiresAt.getTime()) {
      // Session missing or stale in store
      // Try to recover before logout
      try {
        await kratos.setSessionFromWhoami();
        session = store.selectSnapshot(UserState.getSession);
      } catch {
        // session is invalid
      }

      if (!session || Date.now() > session?.expiresAt.getTime()) {
        store.dispatch(new LogoutAction());
        throw new Error('Session expired');
      }
    }

    // check for membership
    if (user.memberships.length == 0) {
      router.navigate(['/localization']);
    }

    return true;
  } catch (ex) {
    console.warn(ex);
    router.navigate(['/login']);
  }

  return true;
};
